
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#252626","d":"M20.5 21a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-8.005-7a.5.5 0 01.5.5v1.502h1.002a.5.5 0 01.36.851l-2.002 3.003a.51.51 0 01-.71 0l-2.002-3.003a.5.5 0 01.35-.851h1.001v-1.501a.5.5 0 01.5-.501zm-.145-9.856l1.997 3a.5.5 0 01-.36.86h-.998v1.5a.5.5 0 01-.5.5h-.999a.5.5 0 01-.5-.5v-1.5h-.997a.499.499 0 01-.35-.85l1.997-3.01a.51.51 0 01.71 0zM20.5 1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z"}})])
          )
        }
      }
    